/// HOOKS ///
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT COMPONENTS ///
import { Fragment } from "react";
/// MUI COMPONENTS ///
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
/// COMPONENTS ///
import DashboardTile from "components/universal/tiles/dashboard";
/// FA ///
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/// ICONS ///
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { faClipboardCheck } from "@fortawesome/free-solid-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { faStore } from "@fortawesome/free-solid-svg-icons";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons";
/// STYLES ///
import { header_style } from "styles/universal/section_header";
import { title_style } from "styles/quote_preview/section";
import { tile_ico_style } from "styles/dashboard";
/// URLS ///
import { end_customer_url } from "components/navigation/endpoints";
import { event_url } from "components/navigation/endpoints";
import { login_url } from "components/navigation/endpoints";
import { order_url } from "components/navigation/endpoints";
import { org_url } from "components/navigation/endpoints";
import { quote_url } from "components/navigation/endpoints";
import { store_url } from "components/navigation/endpoints";
import { stores_url } from "components/navigation/endpoints";
import { wo_url } from "components/navigation/endpoints";

export default function DealerDashboard() {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.authentication);

  if (!user.id) {
    navigate(login_url);
  }

  return (
    <Fragment>
      <Grid container item xs={12} md={6}>
        <Grid item xs={12} sx={{ marginTop: "20px" }}>
          <Typography variant="h6" sx={title_style}>
            Manage Services
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box sx={header_style}></Box>
        </Grid>
        <DashboardTile
          title="Quotes"
          index={0}
          url={`/${store_url}/${quote_url}`}
          icon={<FontAwesomeIcon icon={faFileInvoiceDollar} style={tile_ico_style} />} />
        <DashboardTile
          title="Orders"
          index={1}
          url={`/${store_url}/${order_url}`}
          icon={<FontAwesomeIcon icon={faShoppingCart} style={tile_ico_style} />} />
        <DashboardTile
          title="Work Orders"
          index={2}
          url={`/${wo_url}`}
          icon={<FontAwesomeIcon icon={faClipboardCheck} style={tile_ico_style} />} />
        <DashboardTile
          title="Calendar"
          index={3}
          url={`/${event_url}/month`}
          icon={<FontAwesomeIcon icon={faCalendar} style={tile_ico_style} />} />
        <DashboardTile
          title="Accounts"
          index={4}
          url={`/${end_customer_url}`}
          icon={<FontAwesomeIcon icon={faUserGroup} style={tile_ico_style} />} />
      </Grid>
      <Grid item xs={0} md={6}></Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={12} sx={{ marginTop: "20px" }}>
          <Typography variant="h6" sx={title_style}>
            Manage Organization
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box sx={header_style}></Box>
        </Grid>
        <DashboardTile
          title="Organization"
          index={5}
          url={org_url}
          icon={<FontAwesomeIcon icon={faBuilding} style={tile_ico_style} />} />
        <DashboardTile
          title="Stores"
          index={6}
          url={`${stores_url}`}
          icon={<FontAwesomeIcon icon={faStore} style={tile_ico_style} />} />
      </Grid>
      <Grid item xs={0} md={6}></Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={12} sx={{ marginTop: "20px" }}>
          <Typography variant="h6" sx={title_style}>
            Learn
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box sx={header_style}></Box>
        </Grid>
        <DashboardTile
          title="Latest Updates"
          external={true}
          index={4}
          url="https://learn.arrisstone.com"
          icon={<FontAwesomeIcon icon={faDatabase} style={tile_ico_style} />} />
        <DashboardTile
          title="Training Videos"
          external={true}
          index={5}
          url="https://learn.arrisstone.com/training"
          icon={<FontAwesomeIcon icon={faGraduationCap} style={tile_ico_style} />} />
      </Grid>
    </Fragment>
  )
}
